export default __webpack_public_path__ + "d85e8111d6d41a94f3dc4c32cf9e70a6.png";